var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CChartBar',{attrs:{"datasets":_vm.computedDatasets,"options":_vm.computedOptions,"labels":_vm.labels}})
}
var staticRenderFns = []

export { render, staticRenderFns }